/**
 * Pure isometric coordinate math. Single source of truth for world<->screen
 * transforms. No Phaser, no DOM. Every input handler, NPC placement, and
 * camera lookup MUST go through this module (per ENGN-03 + CONTEXT.md).
 */

export const TILE_W = 64
export const TILE_H = 32
export const HALF_W = TILE_W / 2
export const HALF_H = TILE_H / 2

export interface TileCoord {
  tx: number
  ty: number
}

export interface ScreenCoord {
  sx: number
  sy: number
}

/**
 * True 2:1 isometric projection.
 * Tile (0,0) is the top corner; +x travels screen-east, +y travels screen-south-west.
 */
export function worldToScreen(tx: number, ty: number): ScreenCoord {
  return { sx: (tx - ty) * HALF_W, sy: (tx + ty) * HALF_H }
}

/**
 * Inverse of worldToScreen. Returns fractional tile coordinates; caller
 * floors/rounds based on use case.
 */
export function screenToWorld(sx: number, sy: number): TileCoord {
  return {
    tx: (sx / HALF_W + sy / HALF_H) / 2,
    ty: (sy / HALF_H - sx / HALF_W) / 2,
  }
}
